var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line-wrapbox"},[(_vm.mode == 1)?_c('div',{staticClass:"line-previewbox"},[_c('div',{staticClass:"line"})]):_vm._e(),(_vm.mode == 2)?_c('div',{staticClass:"qr-editor-box"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }